import { userHasRole } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    return Boolean(user);
  },

  view: ({ user, claim }) => {
    // check if user kunde_id matches claim kunde_id
    if (userHasRole(user, ["sysadmin", "accredo", "accredo_buchungsexport"])) {
      return true;
    }

    if (
      claim &&
      user.kunde_id &&
      claim.kunde_id &&
      user.kunde_id === claim.kunde_id
    ) {
      return true;
    }

    return false;
  },

  update: ({ user, claim }) => {
    // check if user kunde_id matches claim kunde_id
    if (userHasRole(user, ["sysadmin", "accredo", "accredo_buchungsexport"])) {
      return true;
    }

    return false;
  },

  updateForm: ({ user, claim }) => {
    // check if user kunde_id matches claim kunde_id
    if (userHasRole(user, ["sysadmin", "accredo", "accredo_buchungsexport"])) {
      return true;
    }

    if (
      claim &&
      user.kunde_id &&
      claim.kunde_id &&
      user.kunde_id === claim.kunde_id
    ) {
      return true;
    }

    return false;
  },

  exportZip: ({ user }) => {
    return userHasRole(user, ["sysadmin", "accredo", "accredo_buchungsexport"]);
  },
};
